/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';


export interface MarkGraphAnnotationAsDeleted$Params {
  graphAnnotationID?: number;
}

export function MarkGraphAnnotationAsDeleted(http: HttpClient, rootUrl: string, params?: MarkGraphAnnotationAsDeleted$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, MarkGraphAnnotationAsDeleted.PATH, 'post');
  if (params) {
    rb.query('graphAnnotationID', params.graphAnnotationID, {});
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
    })
  );
}

MarkGraphAnnotationAsDeleted.PATH = '/api/Graph/MarkGraphAnnotationAsDeleted';
